// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
// import { Row, Col, Form } from "react-bootstrap";
// const ProductView = ({ productData, setProductDetails }) => {
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [editedProductData, setEditedProductData] = useState(productData);
//     const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
//     const [brands, setBrands] = useState({ allBrands: [] });
//     const [vendors, setVendors] = useState({ allVendors: [] });
//     const [editField, setEditField] = useState(null);

//     const fetchCategories = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allCategories = [];

//             const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             allCategories = [...allCategories, ...response.data.category];


//             // All categories for the category dropdown
//             const allCategoriesList = allCategories.filter(cat => !cat.parent_id);

//             // All subcategories (categories with parent_id)
//             const allSubcategories = allCategories.filter(cat => cat.parent_id);

//             setCategories({ allCategoriesList, allSubcategories });
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };
//     const fetchBrands = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allBrands = [];


//             const response = await axios.get(`${backendUrl}/api/brands`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             allBrands = [...allBrands, ...response.data.brand];


//             setBrands({ allBrands });
//         } catch (error) {
//             console.error('Error fetching brands:', error);
//         }
//     };
//     const fetchVendors = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             let allVendors = [];

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             allVendors = [...allVendors, ...response.data.Data];

//             setVendors({ allVendors });

//         } catch (error) {
//             console.error(`Error fetching vendors:`, error);
//         }
//     };
//     const didFetchRef = useRef(false);

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchCategories();
//             fetchBrands();
//             fetchVendors();

//             didFetchRef.current = true;
//         }
//     }, []);
//     const AED_TO_USD = 1 / 3.67; // Conversion rate from AED to USD

//     const [vendorCurrency, setVendorCurrency] = useState("AED");
//     const USD_TO_AED = 3.67;
//     const convertToAED = (value) => (value * USD_TO_AED).toFixed(2);
//     const convertToUSD = (value) => (value * AED_TO_USD).toFixed(2);

//     useEffect(() => {
//         if (productData && vendors.allVendors.length > 0) {
//             // Check if vendor_id exists in the productData
//             if (productData.vendor_id) {
//                 const selectedVendor = vendors.allVendors.find(vendor => String(vendor.id) === String(productData.vendor_id));
//                 if (selectedVendor) {
//                     console.log("Selected Vendor:", selectedVendor);
//                     setVendorCurrency(selectedVendor.currency || "AED");
//                 } else {
//                     console.log("No vendor found for product id:", productData.vendor_id);
//                 }
//             } else {
//                 console.log("Product data does not have a vendor_id");
//             }
//         }
//     }, [productData, vendors.allVendors]);
//     // Trigger this effect when either productData or vendors change


//     const getConvertedPrice = (fieldValue) => {
//         // Check if vendor currency is USD and convert prices accordingly
//         if (vendorCurrency === "USD") {
//             return convertToUSD(fieldValue); // Convert from AED to USD
//         }
//         return fieldValue || ""; // Return the value as is if no conversion is needed
//     };
//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         // Check if the field is a price field
//         const isPriceField = ['selling_price', 'purchase_price', 'min_selling_price','hourly_rate'].includes(name);

//         let updatedValue = value;

//         // If the field is a price field and the currency is USD, convert the value to AED for storage
//         if (isPriceField && vendorCurrency === "USD") {
//             updatedValue = convertToAED(value); // Convert USD input to AED for storage
//         }

//         setEditedProductData((prevState) => ({
//             ...prevState,
//             [name]: updatedValue,
//         }));
//     };
//     const handleSave = async () => {


//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             await axios.put(`${backendUrl}/api/products/${productData.id}`, editedProductData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             setProductDetails((prevDetails) => ({
//                 ...prevDetails,
//                 ...editedProductData, // Update only the changed fields
//             }));
//             setEditField(null);
//         } catch (error) {

//             console.error('Error saving product details:', error);


//         }
//     };


//     // const getConvertedPrice = (fieldValue) => {
//     //     // If vendor currency is USD, convert the price from AED to USD
//     //     if (vendorCurrency === "USD") {
//     //         return convertToAED(fieldValue); // Convert from AED to USD
//     //     }
//     //     return fieldValue || ""; // If AED or no value, return the original value
//     // };

//     const handleVendorChange = (e) => {
//         const selectedVendorId = e.target.value;
//         const selectedVendor = vendors.allVendors.find(vendor => vendor.id === parseInt(selectedVendorId));

//         // Set the selected vendor and its currency
//         setEditedProductData((prev) => ({
//             ...prev,
//             vendor_id: selectedVendorId,
//             vendor_currency: selectedVendor?.currency || "AED", // Update state with vendor's currency
//         }));
//         setVendorCurrency(selectedVendor?.currency || "AED"); // Update currency based on selected vendor
//     };

//     const getPriceLabel = (fieldName) => {
//         if (['selling_price', 'purchase_price', 'min_selling_price'].includes(fieldName)) {
//             return `${fieldName.replace(/_/g, ' ')} (${vendorCurrency})`; // Dynamic label based on currency
//         }
//         return fieldName.replace(/_/g, ' ').toUpperCase(); // Default label
//     };
//     const getCategoryName = (id) => {
//         if (!id || categories.allCategoriesList?.length === 0) return "--";
//         const country = categories.allCategoriesList?.find((coun) => Number(coun.id) === Number(id));
//         return country ? country.name : "--";
//     };
//     const getSubCategoryName = (id) => {
//         if (!id || categories.allSubcategories?.length === 0) return "--";
//         const sub = categories.allSubcategories?.find((subc) => Number(subc.id) === Number(id));
//         return sub ? sub.name : "--";
//     };
//     const getBrandName = (id) => {
//         if (!id || brands?.allBrands?.length === 0) return "--";
//         const brand = brands?.allBrands?.find((bran) => Number(bran.id) === Number(id));
//         return brand ? brand.name : "--";
//     };
//     const getVendorName = (id) => {
//         if (!id || vendors?.allVendors?.length === 0) return "--";
//         const vendor = vendors?.allVendors?.find((ven) => Number(ven.id) === Number(id));
//         return vendor ? vendor.name : "--";
//     };
//     const productTypeOptions = [
//         { value: "1", label: "In-House" },
//         { value: "0", label: "Out-Source" }
//     ];

//     const getProjectTypeLabel = (value) => {
//         const option = productTypeOptions.find(opt => opt.value === value);
//         return option ? option.label : "--";
//     };
//     const fields = [
//         { name: 'product_type', label: 'Product Type', type: 'select', options: [{ value: "single", label: "Single" }, { value: "service", label: "Service" }] },
//         { name: 'product_name', label: 'Product Name', type: 'text' },
//         { name: 'hourly_rate', label: 'Hourly Rate', type: 'text' },
//         { name: 'product_sku', label: 'Product Sku', type: 'text' },
//         { name: 'unit', label: 'Unit', type: 'select', options: [{ value: "qty", label: "Qty" }, { value: "man-days", label: "man-days" }] },
//         { name: 'category_id', label: 'Category', type: 'select', options: categories?.allCategoriesList?.map((coun) => ({ value: coun.id, label: coun.name })), format: getCategoryName },
//         { name: 'subcategory_id', label: 'Sub Category', type: 'select', options: categories?.allSubcategories?.map((sub) => ({ value: sub.id, label: sub.name })), format: getSubCategoryName },
//         { name: 'brand_id', label: 'Brand', type: 'select', options: brands?.allBrands?.map((brand) => ({ value: brand.id, label: brand.name })), format: getBrandName },
//         { name: 'alert_quantity', label: 'Alert Quantity', type: 'text' },
//         { name: 'inhouse', label: 'Product Source', type: 'select', options: productTypeOptions, format: getProjectTypeLabel },
//         { name: 'vendor_id', label: 'Select Vendor', type: 'select', options: vendors?.allVendors?.map((vendor) => ({ value: vendor.id, label: vendor.name })), format: getVendorName },

//         { name: 'selling_price', label: `Selling Price (${vendorCurrency})`, type: 'number' },
//         { name: 'purchase_price', label: `Purchase Price (${vendorCurrency})`, type: 'number' },
//         { name: 'min_selling_price', label: `Min Selling Price (${vendorCurrency})`, type: 'number' },
     
//         { name: 'description', label: 'Description', type: 'text' },

//     ];

//     const visibleFields = fields.filter((field) => {
//         if (isEditMode) {
//             // Show all fields in edit mode, applying product type filtering
//             if (editedProductData.product_type === 'single') {
//                 return field.name !== 'hourly_rate'; // Hide hourly_rate for 'single' type
//             } else if (editedProductData.product_type === 'service') {
//                 return ['product_type', 'product_name', 'hourly_rate','inhouse','vendor_id'].includes(field.name); // Show only these for 'service'
//             }
//             return true; // Default: show all fields
//         } else {
//             // View mode: Show all fields (even if empty) but apply product type filtering
//             if (editedProductData.product_type === 'single') {
//                 return field.name !== 'hourly_rate'; // Hide hourly_rate for 'single' type
//             } else if (editedProductData.product_type === 'service') {
//                 return ['product_type', 'product_name', 'hourly_rate','inhouse','vendor_id'].includes(field.name); // Show only these for 'service'
//             }
//             return true; // Default: show all fields
//         }
//     }).filter((field) => {
//         // Conditionally exclude the vendor_id field if inhouse is '1'
//         if (field.name === 'vendor_id') {
//             return editedProductData.inhouse === '0'; // Show vendor_id only if inhouse is '0'
//         }
//         return true;
//     });
    

//     const rows = [];
//     for (let i = 0; i < visibleFields.length; i += 3) {
//         rows.push(visibleFields.slice(i, i + 3));
//     }



//     const renderField = (field) => {
//         if (field.name === 'category_id') {
//             return (
//                 <select
//                     className="form-control"
//                     name={field.name}
//                     value={editedProductData[field.name] || ''}
//                     disabled={!isEditMode}
//                     onChange={handleChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
//                 >
//                     <option value="">Select a category</option>
//                     {categories?.allCategoriesList?.map((category) => (
//                         <option key={category.id} value={category.id}>
//                             {category.name}
//                         </option>
//                     ))}

//                 </select>
//             );
//         }
//         if (field.name === 'subcategory_id') {
//             return (
//                 <select
//                     className="form-control"
//                     name={field.name}
//                     value={editedProductData[field.name] || ''}
//                     disabled={!isEditMode}
//                     onChange={handleChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
//                 >
//                     <option value="">Select a subcategory</option>
//                     {categories?.allSubcategories?.map((subcat) => (
//                         <option key={subcat.id} value={subcat.id}>
//                             {subcat.name}
//                         </option>
//                     ))}

//                 </select>
//             );
//         }
//         if (field.name === 'brand_id') {
//             return (
//                 <select
//                     className="form-control"
//                     name={field.name}
//                     value={editedProductData[field.name] || ''}
//                     disabled={!isEditMode}
//                     onChange={handleChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
//                 >
//                     <option value="">Select a brand</option>
//                     {brands?.allBrands?.map((brand) => (
//                         <option key={brand.id} value={brand.id}>
//                             {brand.name}
//                         </option>
//                     ))}

//                 </select>
//             );
//         }
//         if (field.name === 'inhouse') {
//             return (
//                 <select
//                     className="form-control"
//                     name={field.name}
//                     value={editedProductData[field.name] || ''}
//                     disabled={!isEditMode}
//                     onChange={handleChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
//                 >
//                     <option value="">Select Type</option>

//                     <option value='1'>In-House</option>
//                     <option value='0'>Out-Source</option>
//                 </select>
//             );
//         }
//         if (field.name === 'vendor_id') {
//             return (
//                 <select
//                     className="form-control"
//                     name={field.name}
//                     value={editedProductData[field.name] || ''}
//                     disabled={!isEditMode}
//                     onChange={handleVendorChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}

//                 >
//                     <option value="">Select Vendor</option>
//                     {vendors?.allVendors?.map((vendor) => (
//                         <option key={vendor.id} value={vendor.id}>
//                             {vendor.name}
//                         </option>
//                     ))}
//                 </select>
//             );
//         }
//         if (['purchase_price', 'selling_price', 'min_selling_price'].includes(field.name)) {
//             return (
//                 <input
//                     className="form-control"
//                     type="number"
//                     name={field.name}
//                     value={getConvertedPrice(editedProductData[field.name]) || ''}

//                     readOnly={!isEditMode}
//                     onChange={handleChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}

//                 />
//             );
//         }

//         if (field.type === 'select') {
//             return (
//                 <select
//                     className="form-control"
//                     name={field.name}
//                     value={editedProductData[field.name] || ''}
//                     disabled={!isEditMode}
//                     onChange={handleChange}
//                     style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
//                 >
//                     <option value="">Select</option>
//                     {field.options.map((option, index) => (
//                         <option key={index} value={option}>
//                             {option.charAt(0).toUpperCase() + option.slice(1)}
//                         </option>
//                     ))}
//                 </select>
//             );
//         }
//         return (
//             <input
//                 className="form-control"
//                 type={field.type}
//                 name={field.name}
//                 value={editedProductData[field.name] || ''}
//                 readOnly={!isEditMode}
//                 onChange={handleChange}
//                 style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
//             />
//         );
//     };
//     console.log("Conversion Trigger:", editedProductData.inhouse, vendorCurrency);




//     return (
//         <div className="p-3 font-size-12">
//             <Row>
//                 {visibleFields.map((field, index) => (
//                     <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
//                         <strong className="view-label me-4">{field.label}:</strong>
//                         <div className="editable-container d-flex align-items-center">
//                             {editField === field.name ? (
//                                 <div className="d-flex align-items-center">
//                                     {['purchase_price', 'selling_price', 'min_selling_price'].includes(field.name) ? (
//                                         <input
//                                         className="form-control form-feild"
//                                         type="number"
//                                             name={field.name}
//                                             value={getConvertedPrice(editedProductData[field.name]) || ''}
//                                             readOnly={!isEditMode}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             style={{
//                                                 fontSize: '14px',
//                                                 maxWidth: '320px',
//                                                 borderRadius: '14px',
//                                                 height: '39px',
//                                                 border: '0.5px solid rgb(232, 233, 237)',
//                                             }}
//                                         />
//                                     ) : field.type === "select" ? (
//                                         <Form.Select
//                                             name={field.name}
//                                             value={editedProductData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                         >
//                                             {field.options.map((option, idx) => (
//                                                 <option key={idx} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </Form.Select>
//                                     ) : field.type === "date" ? (
//                                         <Form.Control
//                                             type="date"
//                                             name={field.name}

//                                             value={editedProductData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                         />
//                                     ) : (
//                                         <Form.Control
//                                             type="text"
//                                             name={field.name}
//                                             value={editedProductData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                         />
//                                     )}
//                                     <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
//                                     <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
//                                 </div>
//                             ) : (
//                                 <div className="hover1">
//                                     {field.name === "category_id" ? (
//                                         <span className="hover-field1">
//                                             {getCategoryName(editedProductData.category_id)}
//                                         </span>
//                                     ) : field.name === "subcategory_id" ? (
//                                         <span className="hover-field1">
//                                             {getSubCategoryName(editedProductData.subcategory_id)}
//                                         </span>
//                                     ) : field.name === "brand_id" ? (
//                                         <span className="hover-field1">
//                                             {getBrandName(editedProductData.brand_id)}
//                                         </span>
//                                     ) : field.name === "vendor_id" ? (
//                                         <span className="hover-field1">
//                                             {getVendorName(editedProductData.vendor_id)}
//                                         </span>
//                                     ) : field.name === "inhouse" ? (
//                                         <span className="hover-field1">
//                                             {getProjectTypeLabel(editedProductData.inhouse)}
//                                         </span>
//                                     ) :['purchase_price', 'selling_price', 'min_selling_price'].includes(field.name) ? (
//                                         <span className="hover-field1">{getConvertedPrice(editedProductData[field.name]) || '--'}</span>
//                                     ) : (
//                                         <span className="hover-field1">{editedProductData[field.name] || "--"}</span>
//                                     )}
//                                     {field.name !== "currency" && (
//                                         <BsPencil className="text-primary pencil-icon1" onClick={() => setEditField(field.name)} />
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </Col>
//                 ))}
//             </Row>
//         </div>
//     );
   

// };

// export default ProductView;




// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { Row, Col, Card, Badge } from "react-bootstrap";
// import { 
//     FaBox, 
//     FaTag, 
//     FaDollarSign, 
//     FaIndustry, 
//     FaLayerGroup,
//     FaBuilding,
//     FaUserTie,
//     FaExclamationTriangle,
//     FaInfoCircle,
//     FaCog,
//     FaShieldAlt,
//     FaCertificate
// } from "react-icons/fa";

// const ProductView = ({ productData, setProductDetails }) => {
//     const [editedProductData, setEditedProductData] = useState(productData);
//     const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
//     const [brands, setBrands] = useState({ allBrands: [] });
//     const [vendors, setVendors] = useState({ allVendors: [] });
//     const [vendorCurrency, setVendorCurrency] = useState("AED");

//     const didFetchRef = useRef(false);

//     const fetchCategories = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader:true,
//             });

//             const allCategories = response.data.category || [];
//             const allCategoriesList = allCategories.filter(cat => !cat.parent_id);
//             const allSubcategories = allCategories.filter(cat => cat.parent_id);

//             setCategories({ allCategoriesList, allSubcategories });
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };

//     const fetchBrands = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/brands`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader:true,
//             });

//             setBrands({ allBrands: response.data.brand || [] });
//         } catch (error) {
//             console.error('Error fetching brands:', error);
//         }
//     };

//     const fetchVendors = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader:true,
//             });

//             setVendors({ allVendors: response.data.Data || [] });
//         } catch (error) {
//             console.error(`Error fetching vendors:`, error);
//         }
//     };

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchCategories();
//             fetchBrands();
//             fetchVendors();
//             didFetchRef.current = true;
//         }
//     }, []);

//     useEffect(() => {
//         setEditedProductData(productData);
//     }, [productData]);

//     // Helper functions
//     const getDisplayValue = (value) => {
//         return value || "--";
//     };

//     const formatCurrency = (amount, currency = "AED") => {
//         if (!amount) return "--";
//         return new Intl.NumberFormat('en-US', {
//             style: 'currency',
//             currency: currency
//         }).format(amount);
//     };

//     const getCategoryName = (id) => {
//         if (!id || categories.allCategoriesList?.length === 0) return "--";
//         const category = categories.allCategoriesList.find(cat => Number(cat.id) === Number(id));
//         return category ? category.name : "--";
//     };

//     const getBrandName = (id) => {
//         if (!id || brands?.allBrands?.length === 0) return "--";
//         const brand = brands.allBrands.find(brand => Number(brand.id) === Number(id));
//         return brand ? brand.name : "--";
//     };

//     const getProductSourceLabel = (value) => {
//         switch (value) {
//             case '1': return 'In-House';
//             case '0': return 'Out-Source';
//             default: return '--';
//         }
//     };

//     const getLicenseTypeLabel = (type) => {
//         switch (type) {
//             case 'license': return 'License';
//             case 'service': return 'Service';
//             default: return '--';
//         }
//     };

//     // Get associated categories from product data
//     const getProductCategories = () => {
//         return productData?.categories || [];
//     };

//     // Get pricing information
//     const getPricingInfo = () => {
//         return productData?.pricings || [];
//     };

//     // Field groups for organized display
//     const fieldGroups = [
//         {
//             title: "Basic Information",
//             icon: <FaInfoCircle className="text-primary" />,
//             fields: [
//                 { 
//                     name: 'product_name', 
//                     label: 'Product Name', 
//                     icon: <FaBox size={14} />, 
//                     value: getDisplayValue(editedProductData?.product_name) 
//                 },
//                 { 
//                     name: 'product_sku', 
//                     label: 'Product SKU', 
//                     icon: <FaTag size={14} />, 
//                     value: getDisplayValue(editedProductData?.product_sku) 
//                 },
//                 { 
//                     name: 'product_code', 
//                     label: 'Product Code', 
//                     icon: <FaTag size={14} />, 
//                     value: getDisplayValue(editedProductData?.product_code) 
//                 },
//                 { 
//                     name: 'license_type', 
//                     label: 'License Type', 
//                     icon: <FaCertificate size={14} />, 
//                     value: getLicenseTypeLabel(editedProductData?.license_type) 
//                 }
//             ]
//         },
//         {
//             title: "Classification",
//             icon: <FaLayerGroup className="text-info" />,
//             fields: [
//                 { 
//                     name: 'brand_id', 
//                     label: 'Brand', 
//                     icon: <FaBuilding size={14} />, 
//                     value: getBrandName(editedProductData?.brand_id) 
//                 },
//                 { 
//                     name: 'inhouse', 
//                     label: 'Product Source', 
//                     icon: <FaShieldAlt size={14} />, 
//                     value: getProductSourceLabel(editedProductData?.inhouse) 
//                 },
//                 { 
//                     name: 'alert_quantity', 
//                     label: 'Alert Quantity', 
//                     icon: <FaExclamationTriangle size={14} />, 
//                     value: getDisplayValue(editedProductData?.alert_quantity)
//                 },
//                 { 
//                     name: 'unit', 
//                     label: 'Unit', 
//                     icon: <FaExclamationTriangle size={14} />, 
//                     value: getDisplayValue(editedProductData?.unit)
//                 },
//                 { 
//                     name: 'purchase_price', 
//                     label: 'Purchase Price', 
//                     icon: <FaDollarSign size={14} />, 
//                     value: getDisplayValue(editedProductData?.purchase_price)
//                 }
//             ]
//         }
//     ];

//     // Pricing card for license models
//     const renderPricingCard = () => {
//         const pricings = getPricingInfo();
//         if (!pricings || pricings.length === 0) return null;

//         return (
//             <Card className="mb-4 shadow-sm border-0">
//                 <Card.Header className="bg-light border-0 py-3">
//                     <div className="d-flex align-items-center">
//                         <FaDollarSign className="text-success" />
//                         <h5 className="mb-0 ms-2 fw-semibold text-dark">License Pricing</h5>
//                     </div>
//                 </Card.Header>
//                 <Card.Body className="p-0">
//                     <Row className="g-0">
//                         {pricings.map((pricing, index) => (
//                             <Col md={6} key={pricing.id}>
//                                 <div className="p-3 border-bottom border-end">
//                                     <div className="d-flex justify-content-between align-items-start mb-2">
//                                         <div>
//                                             <Badge 
//                                                 bg="primary" 
//                                                 className="text-capitalize mb-2"
//                                             >
//                                                 {pricing.license_model}
//                                             </Badge>
//                                             {pricing.is_default_channel && (
//                                                 <Badge bg="success" className="ms-2">
//                                                     Default
//                                                 </Badge>
//                                             )}
//                                         </div>
//                                     </div>
                                    
//                                     <div className="space-y-2">
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Price:</span>
//                                             <span className="fw-semibold text-dark">
//                                             {(pricing.price)}
//                                             </span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Min Price:</span>
//                                             <span className="fw-semibold text-dark">
//                                                 {(pricing.min_price)}
//                                             </span>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <span className="text-muted small">Deployment Cost:</span>
//                                             <span className="fw-semibold text-dark">
//                                                 {(pricing.deployment_cost)}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </Col>
//                         ))}
//                     </Row>
//                 </Card.Body>
//             </Card>
//         );
//     };

//     // Categories card
//     const renderCategoriesCard = () => {
//         const productCategories = getProductCategories();
//         if (!productCategories || productCategories.length === 0) return null;

//         return (
//             <Card className="mb-4 shadow-sm border-0">
//                 <Card.Header className="bg-light border-0 py-3">
//                     <div className="d-flex align-items-center">
//                         <FaIndustry className="text-warning" />
//                         <h5 className="mb-0 ms-2 fw-semibold text-dark">Associated Categories</h5>
//                     </div>
//                 </Card.Header>
//                 <Card.Body>
//                     <div className="d-flex flex-wrap gap-2">
//                         {productCategories.map((category) => (
//                             <Badge 
//                                 key={category.id} 
//                                 bg="outline-primary" 
//                                 className="text-dark border border-primary px-3 py-2"
//                                 style={{ fontSize: '13px' }}
//                             >
//                                 <div className="d-flex align-items-center">
//                                     <FaTag className="me-2" size={12} />
//                                     {category.name}
                                   
//                                 </div>
//                             </Badge>
//                         ))}
//                     </div>
//                 </Card.Body>
//             </Card>
//         );
//     };

//     // Deployment description card
//     const renderDeploymentCard = () => {
//         if (!editedProductData?.deployment_description) return null;

//         return (
//             <Card className="mb-4 shadow-sm border-0">
//                 <Card.Header className="bg-light border-0 py-3">
//                     <div className="d-flex align-items-center">
//                         <FaCog className="text-secondary" />
//                         <h5 className="mb-0 ms-2 fw-semibold text-dark">Deployment Information</h5>
//                     </div>
//                 </Card.Header>
//                 <Card.Body>
//                     <p className="text-dark mb-0" style={{ lineHeight: '1.6' }}>
//                         {editedProductData.deployment_description}
//                     </p>
//                 </Card.Body>
//             </Card>
//         );
//     };

//     return (
//         <div >
           

//             {/* Product Details Sections */}
//             {fieldGroups.map((group, groupIndex) => {
//                 const visibleFields = group.fields.filter(field => 
//                     field.value !== "--" && field.value !== ""
//                 );

//                 if (visibleFields.length === 0) return null;

//                 return (
//                     <Card key={groupIndex} className="mb-4 shadow-sm border-0">
//                         <Card.Header className="bg-light border-0 py-3">
//                             <div className="d-flex align-items-center">
//                                 {group.icon}
//                                 <h5 className="mb-0 ms-2 fw-semibold text-dark">{group.title}</h5>
//                             </div>
//                         </Card.Header>
//                         <Card.Body className="p-0">
//                             <Row className="g-0">
//                                 {visibleFields.map((field, fieldIndex) => (
//                                     <Col md={6} key={fieldIndex}>
//                                         <div className="p-3 border-bottom border-end product-detail-item">
//                                             <div className="d-flex align-items-start">
//                                                 <div className="text-muted me-3 mt-1">
//                                                     {field.icon}
//                                                 </div>
//                                                 <div className="flex-grow-1">
//                                                     <label className="text-muted small mb-1 d-block fw-medium">
//                                                         {field.label}
//                                                     </label>
//                                                     <div className="text-dark fw-semibold">
//                                                         {field.value}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </Col>
//                                 ))}
//                             </Row>
//                         </Card.Body>
//                     </Card>
//                 );
//             })}

//             {/* Categories Card */}
//             {renderCategoriesCard()}

//             {/* Pricing Card */}
//             {renderPricingCard()}

//             {/* Deployment Information Card */}
//             {renderDeploymentCard()}

//             {/* Description Card */}
//             {editedProductData?.description && (
//                 <Card className="shadow-sm border-0">
//                     <Card.Header className="bg-light border-0 py-3">
//                         <div className="d-flex align-items-center">
//                             <FaInfoCircle className="text-secondary" />
//                             <h5 className="mb-0 ms-2 fw-semibold text-dark">Product Description</h5>
//                         </div>
//                     </Card.Header>
//                     <Card.Body>
//                         <p className="text-dark mb-0" style={{ lineHeight: '1.6' }}>
//                             {editedProductData.description}
//                         </p>
//                     </Card.Body>
//                 </Card>
//             )}

//             {/* System Information Card */}
//             {/* <Card className="shadow-sm border-0 mt-4">
//                 <Card.Header className="bg-light border-0 py-3">
//                     <div className="d-flex align-items-center">
//                         <FaCog className="text-secondary" />
//                         <h5 className="mb-0 ms-2 fw-semibold text-dark">System Information</h5>
//                     </div>
//                 </Card.Header>
//                 <Card.Body>
//                     <Row>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="text-muted small mb-1 d-block fw-medium">Product ID</label>
//                                 <div className="text-dark fw-semibold">
//                                     {productData?.id || "--"}
//                                 </div>
//                             </div>
//                         </Col>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="text-muted small mb-1 d-block fw-medium">Created Date</label>
//                                 <div className="text-dark fw-semibold">
//                                     {productData?.created_at ? new Date(productData.created_at).toLocaleDateString() : "--"}
//                                 </div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card.Body>
//             </Card> */}
//         </div>
//     );
// };

// export default ProductView;




import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Row, Col, Card, Badge } from "react-bootstrap";
import { 
    FaBox, 
    FaTag, 
    FaDollarSign, 
    FaIndustry, 
    FaLayerGroup,
    FaBuilding,
    FaUserTie,
    FaExclamationTriangle,
    FaInfoCircle,
    FaCog,
    FaShieldAlt,
    FaCertificate,
    FaStore
} from "react-icons/fa";

const ProductView = ({ productData, setProductDetails }) => {
    const [editedProductData, setEditedProductData] = useState(productData);
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    const [brands, setBrands] = useState({ allBrands: [] });
    const [vendors, setVendors] = useState({ allVendors: [] });
    const [vendorCurrency, setVendorCurrency] = useState("AED");

    const didFetchRef = useRef(false);

    const fetchCategories = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            const allCategories = response.data.category || [];
            const allCategoriesList = allCategories.filter(cat => !cat.parent_id);
            const allSubcategories = allCategories.filter(cat => cat.parent_id);

            setCategories({ allCategoriesList, allSubcategories });
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchBrands = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setBrands({ allBrands: response.data.brand || [] });
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };

    const fetchVendors = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setVendors({ allVendors: response.data.Data || [] });
        } catch (error) {
            console.error(`Error fetching vendors:`, error);
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchCategories();
            fetchBrands();
            fetchVendors();
            didFetchRef.current = true;
        }
    }, []);

    useEffect(() => {
        setEditedProductData(productData);
    }, [productData]);

    // Helper functions
    const getDisplayValue = (value) => {
        return value || "--";
    };

    const formatCurrency = (amount, currency = "AED") => {
        if (!amount) return "--";
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency
        }).format(amount);
    };

    const getCategoryName = (id) => {
        if (!id || categories.allCategoriesList?.length === 0) return "--";
        const category = categories.allCategoriesList.find(cat => Number(cat.id) === Number(id));
        return category ? category.name : "--";
    };

    const getBrandName = (id) => {
        if (!id || brands?.allBrands?.length === 0) return "--";
        const brand = brands.allBrands.find(brand => Number(brand.id) === Number(id));
        return brand ? brand.name : "--";
    };

    const getVendorName = (id) => {
        if (!id || vendors?.allVendors?.length === 0) return "--";
        const vendor = vendors.allVendors.find(vendor => Number(vendor.id) === Number(id));
        return vendor ? vendor.name : "--";
    };

    const getProductSourceLabel = (value) => {
        switch (value) {
            case '1': return 'In-House';
            case '0': return 'Out-Source';
            default: return '--';
        }
    };

    const getProductSourceVariant = (value) => {
        switch (value) {
            case '1': return 'success';
            case '0': return 'warning';
            default: return 'secondary';
        }
    };

    const getLicenseTypeLabel = (type) => {
        switch (type) {
            case 'license': return 'License';
            case 'service': return 'Service';
            default: return '--';
        }
    };

    // Get associated categories from product data
    const getProductCategories = () => {
        return productData?.categories || [];
    };

    // Get pricing information
    const getPricingInfo = () => {
        return productData?.pricings || [];
    };

    // Check if product is outsourced and has vendor
    const isOutsourced = editedProductData?.inhouse === '0';
    const hasVendor = editedProductData?.vendor_id && editedProductData?.vendor_id !== "--";

    // Field groups for organized display
    const fieldGroups = [
        {
            title: "Basic Information",
            icon: <FaInfoCircle className="text-primary" />,
            fields: [
                { 
                    name: 'product_name', 
                    label: 'Product Name', 
                    icon: <FaBox size={14} />, 
                    value: getDisplayValue(editedProductData?.product_name) 
                },
                { 
                    name: 'product_sku', 
                    label: 'Product SKU', 
                    icon: <FaTag size={14} />, 
                    value: getDisplayValue(editedProductData?.product_sku) 
                },
                { 
                    name: 'product_code', 
                    label: 'Product Code', 
                    icon: <FaTag size={14} />, 
                    value: getDisplayValue(editedProductData?.product_code) 
                },
                { 
                    name: 'license_type', 
                    label: 'License Type', 
                    icon: <FaCertificate size={14} />, 
                    value: getLicenseTypeLabel(editedProductData?.license_type) 
                }
            ]
        },
        {
            title: "Classification",
            icon: <FaLayerGroup className="text-info" />,
            fields: [
                { 
                    name: 'brand_id', 
                    label: 'Brand', 
                    icon: <FaBuilding size={14} />, 
                    value: getBrandName(editedProductData?.brand_id) 
                },
                { 
                    name: 'inhouse', 
                    label: 'Product Source', 
                    icon: <FaShieldAlt size={14} />, 
                    value: (
                        <div className="d-flex align-items-center">
                            <Badge 
                                bg={getProductSourceVariant(editedProductData?.inhouse)}
                                className="me-2"
                            >
                                {getProductSourceLabel(editedProductData?.inhouse)}
                            </Badge>
                            {isOutsourced && hasVendor && (
                                <div className="d-flex align-items-center text-warning">
                                    <FaStore size={12} className="me-1" />
                                    <small>{getVendorName(editedProductData?.vendor_id)}</small>
                                </div>
                            )}
                        </div>
                    )
                },
                { 
                    name: 'vendor_id', 
                    label: 'Vendor', 
                    icon: <FaStore size={14} />, 
                    value: isOutsourced ? getVendorName(editedProductData?.vendor_id) : "--",
                    condition: isOutsourced
                },
                { 
                    name: 'alert_quantity', 
                    label: 'Alert Quantity', 
                    icon: <FaExclamationTriangle size={14} />, 
                    value: getDisplayValue(editedProductData?.alert_quantity)
                },
                { 
                    name: 'unit', 
                    label: 'Unit', 
                    icon: <FaExclamationTriangle size={14} />, 
                    value: getDisplayValue(editedProductData?.unit)
                },
                { 
                    name: 'purchase_price', 
                    label: 'Purchase Price', 
                    icon: <FaDollarSign size={14} />, 
                    value: getDisplayValue(editedProductData?.purchase_price)
                }
            ]
        }
    ];

    // Pricing card for license models
    const renderPricingCard = () => {
        const pricings = getPricingInfo();
        if (!pricings || pricings.length === 0) return null;

        return (
            <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0 py-3">
                    <div className="d-flex align-items-center">
                        <FaDollarSign className="text-success" />
                        <h5 className="mb-0 ms-2 fw-semibold text-dark">License Pricing</h5>
                    </div>
                </Card.Header>
                <Card.Body className="p-0">
                    <Row className="g-0">
                        {pricings.map((pricing, index) => (
                            <Col md={6} key={pricing.id}>
                                <div className="p-3 border-bottom border-end">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <Badge 
                                                bg="primary" 
                                                className="text-capitalize mb-2"
                                            >
                                                {pricing.license_model}
                                            </Badge>
                                            {pricing.is_default_channel && (
                                                <Badge bg="success" className="ms-2">
                                                    Default
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <div className="space-y-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Price:</span>
                                            <span className="fw-semibold text-dark">
                                                {(pricing.price)} <small className="text-muted">({pricing.currency || editedProductData.product_currency || 'AED'})</small>
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Min Price:</span>
                                            <span className="fw-semibold text-dark">
                                                {(pricing.min_price)} <small className="text-muted">({pricing.currency || editedProductData.product_currency || 'AED'})</small>
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Deployment Cost:</span>
                                            <span className="fw-semibold text-dark">
                                                {(pricing.deployment_cost)} <small className="text-muted">({pricing.currency || editedProductData.product_currency || 'AED'})</small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>
        );
    };

    // Categories card
    const renderCategoriesCard = () => {
        const productCategories = getProductCategories();
        if (!productCategories || productCategories.length === 0) return null;

        return (
            <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0 py-3">
                    <div className="d-flex align-items-center">
                        <FaIndustry className="text-warning" />
                        <h5 className="mb-0 ms-2 fw-semibold text-dark">Associated Categories</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="d-flex flex-wrap gap-2">
                        {productCategories.map((category) => (
                            <Badge 
                                key={category.id} 
                                bg="outline-primary" 
                                className="text-dark border border-primary px-3 py-2"
                                style={{ fontSize: '13px' }}
                            >
                                <div className="d-flex align-items-center">
                                    <FaTag className="me-2" size={12} />
                                    {category.name}
                                </div>
                            </Badge>
                        ))}
                    </div>
                </Card.Body>
            </Card>
        );
    };

    // Vendor information card (shown only for outsourced products)
    const renderVendorCard = () => {
        if (!isOutsourced || !hasVendor) return null;

        const vendorName = getVendorName(editedProductData?.vendor_id);
        
        return (
            <Card className="mb-4 shadow-sm border-0 border-warning">
                <Card.Header className="bg-warning bg-opacity-10 border-0 py-3">
                    <div className="d-flex align-items-center">
                        <FaStore className="text-warning" />
                        <h5 className="mb-0 ms-2 fw-semibold text-dark">Vendor Information</h5>
                        <Badge bg="warning" className="ms-2">
                            Out-Sourced
                        </Badge>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <div className="d-flex align-items-start mb-3">
                                <div className="text-warning me-3 mt-1">
                                    <FaUserTie size={16} />
                                </div>
                                <div className="flex-grow-1">
                                    <label className="text-muted small mb-1 d-block fw-medium">
                                        Vendor Name
                                    </label>
                                    <div className="text-dark fw-semibold fs-6">
                                        {vendorName}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex align-items-start mb-3">
                                <div className="text-warning me-3 mt-1">
                                    <FaBuilding size={16} />
                                </div>
                                <div className="flex-grow-1">
                                    <label className="text-muted small mb-1 d-block fw-medium">
                                        Product Source
                                    </label>
                                    <div className="text-dark fw-semibold">
                                        <Badge bg="warning" className="text-dark">
                                            Out-Sourced
                                        </Badge>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {editedProductData?.purchase_price && (
                        <Row>
                            <Col md={6}>
                                <div className="d-flex align-items-start">
                                    <div className="text-warning me-3 mt-1">
                                        <FaDollarSign size={16} />
                                    </div>
                                    <div className="flex-grow-1">
                                        <label className="text-muted small mb-1 d-block fw-medium">
                                            Purchase Price
                                        </label>
                                        <div className="text-dark fw-semibold">
                                            {formatCurrency(editedProductData.purchase_price, vendorCurrency)}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Card.Body>
            </Card>
        );
    };

    // Deployment description card
    const renderDeploymentCard = () => {
        if (!editedProductData?.deployment_description) return null;

        return (
            <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0 py-3">
                    <div className="d-flex align-items-center">
                        <FaCog className="text-secondary" />
                        <h5 className="mb-0 ms-2 fw-semibold text-dark">Deployment Information</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    <p className="text-dark mb-0" style={{ lineHeight: '1.6' }}>
                        {editedProductData.deployment_description}
                    </p>
                </Card.Body>
            </Card>
        );
    };

    return (
        <div>
            {/* Vendor Information Card (for outsourced products) */}

            {/* Product Details Sections */}
            {fieldGroups.map((group, groupIndex) => {
                const visibleFields = group.fields.filter(field => {
                    // Show field if it has condition and condition is true, or if no condition and value is not empty
                    if (field.condition !== undefined) {
                        return field.condition;
                    }
                    return field.value !== "--" && field.value !== "" && field.value !== null;
                });

                if (visibleFields.length === 0) return null;

                return (
                    <Card key={groupIndex} className="mb-4 shadow-sm border-0">
                        <Card.Header className="bg-light border-0 py-3">
                            <div className="d-flex align-items-center">
                                {group.icon}
                                <h5 className="mb-0 ms-2 fw-semibold text-dark">{group.title}</h5>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Row className="g-0">
                                {visibleFields.map((field, fieldIndex) => (
                                    <Col md={6} key={fieldIndex}>
                                        <div className="p-3 border-bottom border-end product-detail-item">
                                            <div className="d-flex align-items-start">
                                                <div className="text-muted me-3 mt-1">
                                                    {field.icon}
                                                </div>
                                                <div className="flex-grow-1">
                                                    <label className="text-muted small mb-1 d-block fw-medium">
                                                        {field.label}
                                                    </label>
                                                    <div className="text-dark fw-semibold">
                                                        {field.value}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                );
            })}

            {/* Categories Card */}
            {renderCategoriesCard()}

            {/* Pricing Card */}
            {renderPricingCard()}

            {/* Deployment Information Card */}
            {renderDeploymentCard()}

            {/* Description Card */}
            {editedProductData?.description && (
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-light border-0 py-3">
                        <div className="d-flex align-items-center">
                            <FaInfoCircle className="text-secondary" />
                            <h5 className="mb-0 ms-2 fw-semibold text-dark">Product Description</h5>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <p className="text-dark mb-0" style={{ lineHeight: '1.6' }}>
                            {editedProductData.description}
                        </p>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default ProductView;
